export default "__VITE_ASSET__UUw_dKA4__"